<template>
  <nav :aria-label="$t.utilityNavigationLabel" class="f-col items-start gap-3 body-5">
    <vf-location-selector @click="handleClick($t.locationSelector)" />
    <template v-for="({ type, to, title }, key) in links" :key>
      <vf-link
        v-if="type === 'chat' && $feature.enableChat"
        data-chat="utility-nav"
        variant="quiet"
        @click="handleChat(title)"
      >
        {{ title }}
      </vf-link>
      <vf-link
        v-else-if="type !== 'chat'"
        :to
        variant="quiet"
        @click="handleClick(title)"
      >
        {{ title }}
      </vf-link>
    </template>
    <vf-link
      v-if="giftCardLocales.includes($locale)"
      to="/gift-card-page"
      variant="quiet"
      @click="handleClick($t.giftCardUtilityNavigation)"
    >
      {{ $t.giftCardUtilityNavigation }}
    </vf-link>
    <vf-link
      v-if="$feature.allowFavorites"
      class="flex gap-1"
      to="/favorites"
      variant="quiet"
      @click="handleClick($t.favorites)"
    >
      {{ $t.favorites }}
      <template v-if="favoritesStore.favorites?.length">
        ({{ favoritesStore.favoritesCount }})
      </template>
    </vf-link>
    <client-only>
      <vf-link
        v-if="$feature.enableLoyaltyUtilityNav"
        :to="user?.isLoyaltyMember ? '/account/loyalty' : '/loyalty'"
        variant="quiet"
        @click="handleClick($t.loyaltyUtilityNavLabel)"
      >
        {{ $t.loyaltyUtilityNavLabel }}
      </vf-link>
      <vf-link v-if="auth.loggedIn" variant="quiet" @click="handleSignOut">
        {{ $t.signOut }}
      </vf-link>
    </client-only>
  </nav>
</template>

<script lang="ts" setup>
import type { NavigationLink } from '#types/navigation'

export type Props = {
  links: NavigationLink[]
}

export type Emits = {
  /**
   * Emits when a navigation item is clicked
   */
  click: []
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const { giftCardLocales } = useAppConfig().components.vf.utilityNavigation
const auth = useAuthStore()
const favoritesStore = useFavoritesStore()
const { $chat, $gtm, $t } = useNuxtApp()
const user = useUserStore()

const handleClick = (title: string) => {
  emit('click')
  $gtm.push('topNav.onClickUtilityLink', capitalize(title))
}

const handleChat = (title: string) => {
  handleClick(title)
  $chat.open({ eventLabel: title, buttonLocation: 'utility-nav' })
}

const handleSignOut = () => {
  handleClick($t.signOut)
  auth.logout()
}
</script>
